export const DistributorsTypes = {
  IDistributors: Symbol("IDistributors"),
};
